import { z } from "zod";

import { ClassificationPromptConfigSchema } from "./ClassificationPromptConfig.schema";
import { ExtractionPromptConfigSchema } from "./ExtractionPromptConfig.schema";
import { GenerationPromptConfigSchema } from "./GenerationPromptConfig.schema";
import { SummarisationPromptConfigSchema } from "./SummarisationPromptConfig.schema";
import { TranslationPromptConfigSchema } from "./TranslationPromptConfig.schema";

// ---------------------------------------------------------------------------
// Union: what's stored in AITask.promptGenerationConfig
// Discriminated by the top-level key matching the task category.
// ---------------------------------------------------------------------------

export const PromptGenerationConfigSchema = z.union([
  z.object({ generation: GenerationPromptConfigSchema }),
  z.object({ classification: ClassificationPromptConfigSchema }),
  z.object({ extraction: ExtractionPromptConfigSchema }),
  z.object({ translation: TranslationPromptConfigSchema }),
  z.object({ summarisation: SummarisationPromptConfigSchema })
]);

export type PromptGenerationConfig = z.infer<typeof PromptGenerationConfigSchema>;
